import { Menu } from 'lucide-react';
import type { ReactNode, RefObject } from 'react';
import { Link } from 'react-router-dom';

import { useLanguage } from '../../i18n/language.js';
import { useMerchantWorkspaceIdentity } from '../../merchant/shell-context.js';

/**
 * The compact bar the wireframe shows under 1024px: the drawer trigger, the
 * mark, and the business name. It is not a navigation bar — every
 * destination lives in the drawer it opens.
 */
export function MerchantMobileHeader({
  mobileOpen,
  onMenuOpen,
  triggerRef,
}: {
  readonly mobileOpen: boolean;
  readonly onMenuOpen: () => void;
  readonly triggerRef: RefObject<HTMLButtonElement | null>;
}): ReactNode {
  const { language } = useLanguage();
  const { businessName } = useMerchantWorkspaceIdentity();
  const isArabic = language === 'ar';
  return (
    <header className="mj-merchant-mobile-header">
      <button
        ref={triggerRef}
        type="button"
        className="mj-merchant-icon-button"
        aria-label={isArabic ? 'فتح القائمة' : 'Open menu'}
        aria-controls="merchant-workspace-sidebar"
        aria-expanded={mobileOpen}
        onClick={onMenuOpen}
      >
        <Menu aria-hidden="true" strokeWidth={1.8} />
      </button>
      <Link to="/home" aria-label={isArabic ? 'الرئيسية' : 'Home'}>
        <img
          src={
            isArabic
              ? '/mouja-arabic-pixel-media-logo.svg'
              : '/mouja-pixel-media-logo.svg'
          }
          alt=""
        />
      </Link>
      {businessName ? (
        <span className="mj-merchant-mobile-header-name">{businessName}</span>
      ) : null}
    </header>
  );
}
